import baseStore from './../generic_store'
import Axios from "axios";

const base = baseStore('settings');

const state = {
    ...base.state,
    base_url: '/api/settings',
    resourceName: 'Paramètre(s)',
    model: {}
};

const getters = {
    ...base.getters,
};

const mutations = {
    ...base.mutations,
};

const actions = {
    ...base.actions,
    reset({state, getters, commit, dispatch}, {
        id = state.single.id,
    } = {id: state.single.id}) {
        state.isSavePending = true;

        return Axios.patch(getters.base_url + '/' + id + '/reset')
            .then( () => {
                commit('SET_SINGLE', state.model);
                dispatch('modals/close', null, {root: true})
                dispatch('toasts/add', {type: 'success', message: state.resourceName ? (state.resourceName + ' modifiée') : 'Resource updated'}, {root: true})
            })
            .catch(error => {
                console.warn(error);
            })
            .finally(() => {
                state.isSavePending = false;
            })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
